module.exports = require('./helpers/bundle-url').getBundleURL('krNG3') + "logo-dark.ba5147f0.svg";